import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
interface PoolCloseProgramYearIntervalOptions {
  PoolID: number
  SelectionInterval: string
  DateFrom: string
  DateTo: string
}
export default function CloseProgramIntervalGetObservable(poolId: number): Observable<string> {
  const requestBody: string = new URLSearchParams({
    poolId: poolId.toString()
  }).toString()

  return ObservableFromFetch<string>("FFOrderPoolDefinition/CloseProgramYear?" + requestBody)
}
export  function CloseProgramYearIntervalObservable(data: PoolCloseProgramYearIntervalOptions): Observable<string> {
  const params: string = JSON.stringify(data)
  return ObservableFromFetch<string>("FFOrderPoolDefinition/CloseProgramYearInterval", params)
}
